import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-recovery-filter',
  templateUrl: './recovery-filter.component.html',
  styleUrls: ['./recovery-filter.component.scss']
})
export class RecoveryFilterComponent implements OnInit, OnChanges {

  optionSelected: number;

  @Input() recoverySelected: number;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.recoverySelected) {
      this.optionSelected = this.recoverySelected;
    }
  }

  reset() {
    this.optionSelected = null;
  }

}
